import { render, staticRenderFns } from "./FArticleCategDialog.vue?vue&type=template&id=6c523f74&scoped=true"
import script from "./FArticleCategDialog.vue?vue&type=script&lang=js"
export * from "./FArticleCategDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c523f74",
  null
  
)

export default component.exports